import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

export interface RemoteDocument {
  downloadURL: string;
  id: 'passport' | 'certificate';
}

export interface UserProfile {
  user_id?: string;
  image_url?: string;
  first_name?: string;
  push_token?: string;
  last_name?: string;
  email?: string;
  tel?: string;
  street?: string;
  postal?: string;
  city?: string;
  nationality?: string;
  gender?: string;
  iban?: string;
  docs?: RemoteDocument[];
  level?: number;
  verified?: boolean;
  levels?: {
    current_level?: string;
    next_level?: number;
    required_signatures?: number;
    current_signatures?: number;
    total_required_signatures?: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ProfileDataService {
  private userProfile: BehaviorSubject<UserProfile> =
    new BehaviorSubject<UserProfile>({});

  constructor(private _http: HttpClient) {
  }

  async updateProfile(profile: UserProfile) {
    try {
      await firstValueFrom(
        this._http.put(`${environment.apiUrl}/user`, profile),
      );
      this.userProfile.next({ ...this.userProfile.getValue(), ...profile });
    } catch (error) {
      throw new Error('Konnte Profil nicht aktualisieren.');
    }
  }

 

  getUserProfile() {
    const profile = { ...this.userProfile.getValue() };
    if (!profile.image_url) {
      profile.image_url = '/assets/images/default-avatar.jpg';
    }
    return profile;
  }

  getUserProfileObservable() {
    return this.userProfile.asObservable();
  }
}